import type { BrowserInfo } from '@is24/is24-checkout-js/dist/@types/models/browser-info';
import { post } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { APP_CONFIG } from '@/config';
import type { Product, UpsellPurchaseResponse } from '@/@types/upsell';

export const upsellPurchase = async (
  product: Product,
  browserInfo: BrowserInfo,
  googlePlayExternalTransactionToken?: string,
  trackingInfo?: string,
) => {
  const url = new URL(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.upsellPurchase}`);
  url.searchParams.append('product', product);

  return await post<
    UpsellPurchaseResponse,
    { browserInfo: BrowserInfo; googlePlayExternalTransactionToken?: string; trackingInfo?: string }
  >(url.toString(), {
    browserInfo,
    ...(googlePlayExternalTransactionToken && { googlePlayExternalTransactionToken }),
    ...(trackingInfo !== undefined && { trackingInfo }),
  });
};
